import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import CompanyUser from "./CompanyUser";
import GridConfig from "../GridConfig";
import ImportExcel from "../ImportExcel";
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class CompanyUsers extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            companyId: props.CompanyId,
            controllerName: 'company/user',
            data: null,
            loading: true,
            configName: 'companyusers_grid',
            moduleName: 'کاربران کسب و کار',
            menuId: 14
        };
        this.state.filters = {
            companyId: this.state.companyId
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <CompanyUser Caller={this} Id={id} CompanyId={this.state.companyId} />
        });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <CompanyUser Caller={this} CompanyId={this.state.companyId} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "name", caption: "نام کاربر", show: true },
                { field: "mobile", caption: "شماره موبایل", show: true },
                { field: "relationString", caption: "نقش", show: true },
                { field: "createDatePersian", caption: "تاریخ ثبت", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'name' && f.show) t.push({ field: f.field, headerName: f.caption, flex: 3, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.name}</a> } });
            if (f.field == 'mobile' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'relationString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDatePersian' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: 'id', filter: false, headerName: 'عملیات', cellRenderer: (props) => {
                return [
                    <a className="hand text-danger" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-trash"></em><span>حذف</span></a>
                ]
            }
        });
        return t;
    }
    onImport() {
        this.removeKeyDown();
        this.showComponents({ component: <ImportExcel Caller={this} Type={14} CompanyId={this.state.data.global.company.id} /> });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();

        return (
            <div>
                <div className="nk-content-body">
                    <div className="nk-block">
                                {this.getToolBar(false, {
                                    add: true, print: false, pdf: false, excell: false, remove: false, config: false,
                                    otherFilters: <a onClick={e => this.onImport()} className="ms-2 hand btn btn-success"><span>ورود اکسل</span></a>
                                })}
                        {this.renderAgGrid({
                            columnDefs: this.getColumns()
                        })}
                    </div>
                </div>
            </div>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}